'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});
exports.default = void 0;
var _react = _interopRequireDefault(require('react'));
var _base = require('@atlaskit/icon/base');
function _interopRequireDefault(e) {
	return e && e.__esModule ? e : { default: e };
}
const Folder24Icon = (props) =>
	/*#__PURE__*/ _react.default.createElement(
		_base.IconFacade,
		Object.assign(
			{
				dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="#b3d4ff" fill-rule="evenodd"><path d="M10 4h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2"/><path d="M0 6h24v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" style="mix-blend-mode:multiply"/></g></svg>`,
			},
			props,
			{
				size: 'medium',
			},
		),
	);
Folder24Icon.displayName = 'Folder24Icon';
var _default = (exports.default = Folder24Icon);
